import * as React from 'react';
import { cn } from '../../utils/cn';
import { FormItemContext } from './form';

export const FormItem = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
    const id = React.useId();

    return (
        <FormItemContext.Provider value={{ id }}>
            <div
                ref={ref}
                className={cn('[&>*:not(:first-child)]:mt-2', className)}
                {...props}
            />
        </FormItemContext.Provider>
    );
});

FormItem.displayName = 'FormItem';
